import { Translation } from './pt-BR'

const messages: Translation = {
  filter: {
    apply: 'Aplique',
    cleanFilters: 'Limpieza de filtros',
    filter: 'Filtros',
    clean: 'Limpieza',
    price: 'Precio',
    to: 'a',
    currency: '$',
    sort: {
      title: 'Ordenar',
      newest: 'Más reciente',
      oldest: 'Más antiguo',
      lowest: 'Precio más bajo',
      highest: 'Precio más alto',
      az: 'Alfabético',
      za: 'Alfabético inverso'
    },
    displayModeError: 'El modo de visualización elegido no es válido.',
    search: {
      placeholder: 'Introduzca su búsqueda',
      cta: 'Pulsa enter'
    }
  }
}

export { messages }
